import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { ContentEmailSpecFragment } from 'api';
import { DAILY_SECONDS, WEEKLY_SECONDS, MONTHLY_SECONDS } from 'features/admin/constants';

interface IProps {
  interval: ContentEmailSpecFragment['delivery_interval'];
}

const DeliveryInterval: FC<IProps> = ({ interval }) => {
  const { t } = useTranslation();

  switch (interval) {
    case DAILY_SECONDS:
      return <Fragment>{t('contentEmails:repeatDaily')}</Fragment>;
    case WEEKLY_SECONDS:
      return <Fragment>{t('contentEmails:repeatWeekly')}</Fragment>;
    case MONTHLY_SECONDS:
      return <Fragment>{t('contentEmails:repeatMonthly')}</Fragment>;
    default:
      return <Fragment>{t('contentEmails:repeatNone')}</Fragment>;
  }
};

export default DeliveryInterval;
